import { Money } from '@dreryk/money-common-api';

import { TextView } from '@dreryk/react-components';
import { getCustomFormattingContext, priceFormatter } from '@dreryk/react-common';

import { translationKeys } from '../translations';

type AdvancePaymentPendingOnlinePaymentsTotalAmountTextViewProps = Readonly<{
   pendingOnlinePaymentsTotalAmount: Money;
}>;

export const AdvancePaymentPendingOnlinePaymentsTotalAmountTextView = (
   props: AdvancePaymentPendingOnlinePaymentsTotalAmountTextViewProps
): JSX.Element => {
   return (
      <TextView
         testId={'advancePaymentPendingOnlinePaymentsTotalAmount'}
         label={translationKeys.advancePaymentPendingOnlinePaymentsTotalAmount}
      >
         {priceFormatter(
            props.pendingOnlinePaymentsTotalAmount.asNumber(),
            getCustomFormattingContext({
               options: {
                  currency: 'PLN',
                  stripDecimalZeroes: true,
               },
            })
         )}
      </TextView>
   );
};
